/**
 * @Description: 简单的封装一下视频播放器
 * @author zhaijiayu
 * @date 2021/9/6
*/
<template>
  <div :style="{width: width + 'px'}">
    <video-player
        :options="{
        ...defaultPlayerOption,
        sources: [{
          src: source,  // 路径
          type: 'video/mp4'  // 类型
        }],
        poster: cover,
        aspectRatio: ratio
      }"
    />
  </div>

</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  name: "video-player.vue",
  components: {
    videoPlayer
  },
  props: {
    cover: String,
    source: String,
    width: Number,
    ratio: String
  },
  data: function (){
    return {
      defaultPlayerOption: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '2:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.video-js .vjs-big-play-button{
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
</style>